import React from "react";
import { graphql, StaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import Header from "../components/Header";
import MainLayout from "../components/MainLayout";
import Seo from "../components/Head";
import CrewSlider from "../components/CrewSlider";
import DogSlider from "../components/DogSlider";
import Prefooter from "../components/Prefooter";
import Heading from "../components/Heading";
import { H2, H4, Paragraph } from "../components/Utilities";
import Salt from "../components/Salt";

import Painting from "../components/PaintingImage";
import Beach from "../images/the-crew/beach.jpg";

const TheCrew = () => {
  
  const showDogSlider = () => {
    const dogSlider = document.getElementById("office-dogs");
    if (dogSlider.classList.contains("opacity-0")) {
      dogSlider.classList.remove("opacity-0", "h-0", "hidden");
      dogSlider.classList.add("lg:h-[800px]");
    } else {
      dogSlider.classList.add("opacity-0", "h-0", "hidden");
      dogSlider.classList.remove("lg:h-[800px]");
    }
  };
  return (
    <StaticQuery
      query={graphql`
        {
          allWpPage(filter: { title: { eq: "The Crew" } }) {
            edges {
              node {
                template {
                  ... on WpDefaultTemplate {
                    footerContent {
                      footerTitle
                      footerDescription
                      footerBackground {
                        altText
                        sourceUrl
                      }
                    }
                  }
                }
                crew {
                  heroDescription
                  heroSalt
                  heroTitle
                  numbersDescription
                  numbersSubtitle
                  numbersTitle
                  metaTitle
                  metaDescription
                  number {
                    statistic
                    title
                    details
                  }
                  department {
                    description
                    title
                    crewMembers {
                      biography
                      jobTitle
                      name                      
                      startingDate
                      largeProfile {
                        altText
                        sourceUrl
                      }
                      questions {
                        question
                        response
                      }
                      smallProfile {
                        altText
                        sourceUrl
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={(props) => (
        <MainLayout>          
          <Header />
          <Seo
            meta_title={props.allWpPage.edges[0].node.crew.metaTitle}
            meta_title_backup={props.allWpPage.edges[0].node.crew.heroTitle}
            meta_description={
              props.allWpPage.edges[0].node.crew.metaDescription
            }
          />
          <section
            className="lg:pt-[65px] max-w-screen-2xl mx-auto relative z-10 overflow-hidden"
            id="hero"
          >
            <div className="grid md:grid-cols-6 relative z-10 md:pl-28">
              <div className="col-span-4">
                <div className="bg-iron px-8 md:px-10 py-32 lg:pt-24 md:pb-32 lg:px-24">
                  <Heading
                    text={props.allWpPage.edges[0].node.crew.heroTitle}
                    alignment={"justify-start"}
                  />
                  <Paragraph
                    content={props.allWpPage.edges[0].node.crew.heroDescription}
                    classes={"text-smoke mt-7"}
                  />
                </div>
              </div>
            </div>
            <div className="max-w-screen-xl mx-auto relative z-10 h-[600px] sm:h-[700px] md:h-[600px]">
              <div className="absolute -top-5 lg:-top-32 left-0">
                <div className="grid grid-cols-2 md:grid-cols-3 relative z-10">
                  <div className="translate-y-5 md:translate-y-28 w-60 md:w-full">
                    <StaticImage
                      src="../images/the-crew/bonfire.jpg"
                      alt="Bonfire at beach"
                    />
                  </div>
                  <div className="md:col-span-2 grid md:grid-cols-2 items-end md:-translate-x-20 relative">
                    <StaticImage
                      src="../images/the-crew/dwayne.jpg"
                      alt="Dwayne checking out the boats"
                      className="w-[225px] sm:w-[350px] -ml-5 sm:ml-auto -translate-y-10 md:translate-y-0"
                    />
                    <StaticImage
                      src="../images/the-crew/tim-emma.jpg"
                      alt="Emma and tim in conference room"
                      className="-translate-x-4 md:translate-x-5 translate-y-10 md:translate-y-0"
                    />
                    <div className="absolute bottom-40 sm:bottom-52 md:-bottom-14 md:left-0 -translate-x-20 md:translate-x-0">
                      <Salt
                        title={props.allWpPage.edges[0].node.crew.heroSalt}
                        range={[0, 0.1]}
                        classes={"w-[250px] md:w-full text-center"}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3">
                  <div className="hidden md:block"></div>
                  <StaticImage
                    src="../images/the-crew/ship.jpg"
                    alt={"Illustration of ship crashing into beach"}
                    className="translate-y-10 md:translate-y-0 translate-x-5 md:translate-x-0 w-[225px] md:w-[340px] ml-auto"
                  />
                  <Painting />
                </div>
              </div>
            </div>
            <img
              src={Beach}
              alt="Beach with tide"
              className="absolute bottom-52 md:bottom-0 left-0 w-[700px] z-0"
            />
          </section>

          {props.allWpPage.edges[0].node.crew.department.map((dept, index) => {
            if (!dept) return null;
            
            const isFirst = index === 0;
            const isEven = index % 2 === 0;
            const isDogSection = dept.title?.toLowerCase().includes("dog");
            const crewCount = dept.crewMembers?.length || 0;
            const isSmallSlider = crewCount <= 2;
            
            const bgClass = isFirst ? "bg-bronze" : (isEven ? "bg-iron" : "");
            const textClass = isFirst ? "text-ink" : "text-smoke";
            const sectionId = dept.title?.toLowerCase().replace(/\s+/g, '-') || `department-${index}`;
            
            if (isDogSection) {
              return (
                <section
                  key={sectionId}
                  id="office-dogs"
                  className="opacity-0 transition-all duration-500 h-0 hidden sm:block"
                >
                  <div className="max-w-screen-xl mx-auto mt-5 grid md:grid-cols-2 px-8 pb-14 md:px-20">
                    <H2 title={dept.title} classes={"mb-4 lg:mb-0"} />
                    <Paragraph content={dept.description} classes={"text-smoke"} />
                  </div>
                  <DogSlider
                    data={{
                      container_classes: "overflow-hidden pt-4 md:pt-16 mb-28",
                      slider_classes: "relative sm:translate-x-[115px] z-20 px-4 md:px-8",
                      slide_classes: "",
                      crew_members: dept.crewMembers || [],
                      slides_to_show: 5,
                      arrow_type: "smoke",
                      draggable: true,
                      response: [
                        { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 2 } },
                        { breakpoint: 900, settings: { slidesToShow: 2 } },
                      ],
                    }}
                  />
                </section>
              );
            }
            
            return (
              <section
                key={sectionId}
                id={sectionId}
                className={`relative ${index > 0 ? "mt-5" : ""}`}
              >
                {bgClass ? (
                  <div className={`${bgClass} relative z-10`}>
                    <div className="max-w-screen-xl mx-auto grid md:grid-cols-2 px-8 pt-20 pb-32 md:pb-40 md:px-20">
                      <H2 title={dept.title} classes={"mb-4 lg:mb-0"} />
                      <Paragraph content={dept.description} classes={textClass} />
                    </div>
                  </div>
                ) : (
                  <div className="max-w-screen-xl mx-auto mt-5 grid md:grid-cols-2 px-8 pb-14 md:px-20">
                    <H2 title={dept.title} classes={"mb-4 lg:mb-0"} />
                    <Paragraph content={dept.description} classes={textClass} />
                  </div>
                )}
                
                {bgClass && !isFirst && (
                  <div className="bg-iron w-full absolute top-[280px] sm:top-[250px] h-[200px] left-0"></div>
                )}
                
                <div className={isSmallSlider ? "max-w-screen-xl mx-auto" : ""}>
                  <CrewSlider
                    data={{
                      container_classes: isSmallSlider
                        ? `${isFirst ? "mt-12 md:mt-20" : "mt-36 md:mt-44"} max-w-screen-sm mx-auto xl:mx-0 xl:ml-auto`
                        : "overflow-hidden pt-4 md:pt-16 mb-28",
                      single_container_classes: isSmallSlider ? "-translate-y-16 relative z-10" : "",
                      slider_classes: isSmallSlider
                        ? "relative z-20 -translate-y-28 md:-translate-y-40 px-4 md:px-0"
                        : "relative sm:translate-x-[115px] z-20 px-4 md:px-8",
                      crew_members: dept.crewMembers || [],
                      slides_to_show: isSmallSlider ? 2 : (crewCount >= 4 ? 4 : crewCount),
                      arrow_type: isSmallSlider ? "none" : (crewCount > 3 ? "smoke" : "none"),
                      draggable: !isSmallSlider,
                      response: [
                        {
                          breakpoint: 1200,
                          settings: {
                            slidesToShow: isSmallSlider ? 2 : 3,
                            slidesToScroll: 2,
                            infinite: true,
                            dots: false,
                          },
                        },
                        ...(isSmallSlider ? [] : [{ breakpoint: 900, settings: { slidesToShow: 2 } }]),
                      ],
                    }}
                  />
                </div>
              </section>
            );
          })}

          <section
            className="max-w-screen-xl mx-auto relative z-10 mb-14 md:mb-32"
            id="by-the-numbers"
          >
            <div className="bg-bronze grid md:grid-cols-2 md:gap-x-32 px-8 py-20 md:px-20 md:py-28">
              <div>
                <H4
                  title={props.allWpPage.edges[0].node.crew.numbersSubtitle}
                  classes={"text-smoke"}
                />
                <H2
                  title={props.allWpPage.edges[0].node.crew.numbersTitle}
                  classes={"text-smoke"}
                />
                <Paragraph
                  content={
                    props.allWpPage.edges[0].node.crew.numbersDescription
                  }
                  classes={"text-ink mt-3 md:mt-7"}
                />
              </div>
              <div className="mt-12 md:mt-0">
                <ul className="grid text-center md:text-left lg:grid-cols-2 gap-14 sm:gap-10 lg:gap-14">
                  {props.allWpPage.edges[0].node.crew.number.map((card) => {
                    return (
                      <li key={card.title}>
                        {card.title.toLowerCase().includes("dog") ? (
                          <button
                            className="flex flex-col group items-center sm:items-start w-full sm:w-auto"
                            onClick={showDogSlider}
                          >
                            <p className="text-smoke text-lg font-bold rift uppercase leading-[18px]">
                              {card.title}
                            </p>
                            <p className="text-ink text-5xl gin-regular uppercase leading-[48px] transition-all duration-300   group-hover:text-smoke">
                              {card.statistic}
                            </p>
                          </button>
                        ) : (
                          <>
                            <p className="text-smoke text-lg font-bold rift uppercase leading-[18px]">
                              {card.title}
                            </p>
                            <p className="text-ink text-5xl gin-regular uppercase leading-[48px]">
                              {card.statistic}
                            </p>
                          </>
                        )}
                        <span className="text-ink text-lg font-bold rift uppercase leading-[18px]">
                          {card.details}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </section>

          <Prefooter
            title={
              props.allWpPage.edges[0].node.template.footerContent.footerTitle
            }
            description={
              props.allWpPage.edges[0].node.template.footerContent
                .footerDescription
            }
            background={
              props.allWpPage.edges[0].node.template.footerContent
                .footerBackground
            }
          />
        </MainLayout>
      )}
    />
  );
};

export default TheCrew;
